export const actionTypes = {
  GET_USER_WITH_ALREADY_EXISTING_FISCAL_CODE:
    "GET_USER_WITH_ALREADY_EXISTING_FISCAL_CODE",
  GET_USER_WITH_ALREADY_EXISTING_FISCAL_CODE_SUCCESS:
    "GET_USER_WITH_ALREADY_EXISTING_FISCAL_CODE_SUCCESS",
  GET_USER_WITH_ALREADY_EXISTING_FISCAL_CODE_FAILURE:
    "GET_USER_WITH_ALREADY_EXISTING_FISCAL_CODE_FAILURE",
  GET_OU_BY_USERTYPE: "GET_OU_BY_USERTYPE",
  SAVE_SOCIETY_VALIDATION: "SAVE_SOCIETY_VALIDATION",
  SAVE_SOCIETY_VALIDATION_SUCCESS: "SAVE_SOCIETY_VALIDATION_SUCCESS",
  SAVE_SOCIETY_VALIDATION_FAILURE: "SAVE_SOCIETY_VALIDATION_FAILURE",
  GET_OFFICES: "GET_OFFICES",
  GET_OFFICES_SUCCESS: "GET_OFFICES_SUCCESS",
  GET_OFFICES_FAILURE: "GET_OFFICES_FAILURE",
  GET_COMPANIES: "GET_COMPANIES",
  GET_COMPANIES_SUCCESS: "GET_COMPANIES_SUCCESS",
  GET_COMPANIES_FAILURE: "GET_COMPANIES_FAILURE",
  BLOCK_USER: "BLOCK_USER",
  BLOCK_USER_SUCCESS: "BLOCK_USER_SUCCESS",
  BLOCK_USER_FAILURE: "BLOCK_USER_FAILURE",
  RENEW_USER: "RENEW_USER",
  RENEW_USER_SUCCESS: "RENEW_USER_SUCCESS",
  RENEW_USER_FAILURE: "RENEW_USER_FAILURE",
  RENEW_USER_ADMIN: "RENEW_USER_ADMIN",
  RENEW_USER_ADMIN_SUCCESS: "RENEW_USER_ADMIN_SUCCESS",
  RENEW_USER_ADMIN_FAILURE: "RENEW_USER_ADMIN_FAILURE",
  REACTIVATE_OUTSOURCER: "REACTIVATE_OUTSOURCER",
  REACTIVATE_OUTSOURCER_SUCCESS: "REACTIVATE_OUTSOURCER_SUCCESS",
  REACTIVATE_OUTSOURCER_FAILURE: "REACTIVATE_OUTSOURCER_FAILURE",
  REACTIVATE_CONSULTANT: "REACTIVATE_CONSULTANT",
  REACTIVATE_CONSULTANT_SUCCESS: "REACTIVATE_CONSULTANT_SUCCESS",
  REACTIVATE_CONSULTANT_FAILURE: "REACTIVATE_CONSULTANT_FAILURE",
  REACTIVATE_USER: "REACTIVATE_USER",
  REACTIVATE_USER_SUCCESS: "REACTIVATE_USER_SUCCESS",
  REACTIVATE_USER_FAILURE: "REACTIVATE_USER_FAILURE",
  REACTIVATE_ADMIN: "REACTIVATE_ADMIN",
  REACTIVATE_ADMIN_SUCCESS: "REACTIVATE_ADMIN_SUCCESS",
  REACTIVATE_ADMIN_FAILURE: "REACTIVATE_ADMIN_FAILURE",
  TERMINATE_OUTSOURCER: "TERMINATE_OUTSOURCER",
  TERMINATE_OUTSOURCER_SUCCESS: "TERMINATE_OUTSOURCER_SUCCESS",
  TERMINATE_OUTSOURCER_FAILURE: "TERMINATE_OUTSOURCER_FAILURE",
  TERMINATE_CONSULTANT: "TERMINATE_CONSULTANT",
  TERMINATE_CONSULTANT_SUCCESS: "TERMINATE_CONSULTANT_SUCCESS",
  TERMINATE_CONSULTANT_FAILURE: "TERMINATE_CONSULTANT_FAILURE",
  TERMINATE_SECURITY: "TERMINATE_SECURITY",
  TERMINATE_SECURITY_SUCCESS: "TERMINATE_SECURITY_SUCCESS",
  TERMINATE_SECURITY_FAILURE: "TERMINATE_SECURITY_FAILURE",
  VALIDATE_USERS: "VALIDATE_USERS",
  VALIDATE_USERS_SUCCESS: "VALIDATE_USERS_SUCCESS",
  VALIDATE_USERS_FAILURE: "VALIDATE_USERS_FAILURE",
  DISABLE_OUTSOURCER: "DISABLE_OUTSOURCER",
  DISABLE_OUTSOURCER_SUCCESS: "DISABLE_OUTSOURCER_SUCCESS",
  DISABLE_OUTSOURCER_FAILURE: "DISABLE_OUTSOURCER_FAILURE",
  DISABLE_CONSULTANT: "DISABLE_CONSULTANT",
  DISABLE_CONSULTANT_SUCCESS: "DISABLE_CONSULTANT_SUCCESS",
  DISABLE_CONSULTANT_FAILURE: "DISABLE_CONSULTANT_FAILURE",
  GET_ALL_ROLES_REQUEST: "GET_ALL_ROLES_REQUEST",
  GET_ALL_ROLES_REQUEST_SUCCESS: "GET_ALL_ROLES_REQUEST_SUCCESS",
  GET_ALL_ROLES_REQUEST_FAILURE: "GET_ALL_ROLES_REQUEST_FAILURE",
  MODIFY_SELECTED_USERS: "MODIFY_SELECTED_USERS",
  GET_USERS_VALIDATION_INFO: "GET_USERS_VALIDATION_INFO",
  GET_USERS_VALIDATION_INFO_SUCCESS: "GET_USERS_VALIDATION_INFO_SUCCESS",
  GET_USERS_VALIDATION_INFO_FAILURE: "GET_USERS_VALIDATION_INFO_FAILURE",
  SET_USER_DETAIL: "SET_USER_DETAIL",
  SET_ROLE_SELECTED_REQUEST: "SET_ROLE_SELECTED_REQUEST",
  PAGINATED_USERS_REQUEST: "PAGINATED_USERS_REQUEST",
  PAGINATED_USERS_REQUEST_SUCCESS: "PAGINATED_USERS_REQUEST_SUCCESS",
  PAGINATED_USERS_REQUEST_FAILURE: "PAGINATED_USERS_REQUEST_FAILURE",
  UPDATE_USER_INFO: "UPDATE_USER_INFO",
  UPDATE_USER_INFO_SUCCESS: "UPDATE_USER_INFO_SUCCESS",
  UPDATE_USER_INFO_FAILURE: "UPDATE_USER_INFO_FAILURE",
  ENABLE_BADGE_TO_USER: "ENABLE_BADGE_TO_USER",
  ENABLE_BADGE_TO_USER_SUCCESS: "ENABLE_BADGE_TO_USER_SUCCESS",
  ENABLE_BADGE_TO_USER_FAILURE: "ENABLE_BADGE_TO_USER_FAILURE",
  GET_USER_ATTACHMENTS_INFO: "GET_USER_ATTACHMENTS_INFO",
  GET_USER_ATTACHMENTS_INFO_SUCCESS: "GET_USER_ATTACHMENTS_INFO_SUCCESS",
  GET_USER_ATTACHMENTS_INFO_FAILURE: "GET_USER_ATTACHMENTS_INFO_FAILURE",
  GET_USER_ADMIN_LETTERS_INFO: "GET_USER_ADMIN_LETTERS_INFO",
  GET_USER_ADMIN_LETTERS_INFO_SUCCESS: "GET_USER_ADMIN_LETTERS_INFO_SUCCESS",
  GET_USER_ADMIN_LETTERS_INFO_FAILURE: "GET_USER_ADMIN_LETTERS_INFO_FAILURE",
  UPLOAD_ATTACHMENTS_TO_ADMIN_LETTERS: "UPLOAD_ATTACHMENTS_TO_ADMIN_LETTERS",
  UPLOAD_ATTACHMENTS_TO_ADMIN_LETTERS_SUCCESS:
    "UPLOAD_ATTACHMENTS_TO_ADMIN_LETTERS_SUCCESS",
  UPLOAD_ATTACHMENTS_TO_ADMIN_LETTERS_FAILURE:
    "UPLOAD_ATTACHMENTS_TO_ADMIN_LETTERS_FAILURE",
  UPLOAD_ATTACHMENTS_TO_USERS: "UPLOAD_ATTACHMENTS_TO_USERS",
  UPLOAD_ATTACHMENTS_TO_USERS_SUCCESS: "UPLOAD_ATTACHMENTS_TO_USERS_SUCCESS",
  UPLOAD_ATTACHMENTS_TO_USERS_FAILURE: "UPLOAD_ATTACHMENTS_TO_USERS_FAILURE",
  GET_MANAGERS_REFERRALS: "GET_MANAGERS_REFERRALS",
  GET_MANAGERS_REFERRALS_SUCCESS: "GET_MANAGERS_REFERRALS_SUCCESS",
  GET_MANAGERS_REFERRALS_FAILURE: "GET_MANAGERS_REFERRALS_FAILURE",
  GET_MANAGERS: "GET_MANAGERS",
  GET_MANAGERS_SUCCESS: "GET_MANAGERS_SUCCESS",
  GET_MANAGERS_FAILURE: "GET_MANAGERS_FAILURE",
  GET_REFERRALS: "GET_REFERRALS",
  GET_REFERRALS_SUCCESS: "GET_REFERRALS_SUCCESS",
  GET_REFERRALS_FAILURE: "GET_REFERRALS_FAILURE",
  GET_ORGANIZATIONAL_UNITS: "GET_ORGANIZATIONAL_UNITS",
  GET_ORGANIZATIONAL_UNITS_SUCCESS: "GET_ORGANIZATIONAL_UNITS_SUCCESS",
  GET_ORGANIZATIONAL_UNITS_FAILURE: "GET_ORGANIZATIONAL_UNITS_FAILURE",
  GET_ORGANIZATIONAL_UNITS_BY_SELECTED_ROLES:
    "GET_ORGANIZATIONAL_UNITS_BY_SELECTED_ROLES",
  GET_ORGANIZATIONAL_UNITS_BY_SELECTED_ROLES_SUCCESS:
    "GET_ORGANIZATIONAL_UNITS_BY_SELECTED_ROLES_SUCCESS",
  GET_ORGANIZATIONAL_UNITS_BY_SELECTED_ROLES_FAILURE:
    "GET_ORGANIZATIONAL_UNITS_BY_SELECTED_ROLES_FAILURE",
  GET_BUTTONS: "GET_BUTTONS",
  GET_BUTTONS_SUCCESS: "GET_BUTTONS_SUCCESS",
  GET_BUTTONS_FAILURE: "GET_BUTTONS_FAILURE",
  GET_FIELD_VISIBILITY: "GET_FIELD_VISIBILITY",
  GET_FIELD_VISIBILITY_SUCCESS: "GET_FIELD_VISIBILITY_SUCCESS",
  GET_FIELD_VISIBILITY_FAILURE: "GET_FIELD_VISIBILITY_FAILURE",
  RESET_STATE_EXTERNAL_PORTAL: "RESET_STATE_EXTERNAL_PORTAL",
  UPDATE_REACTIVATE_RENEW_ADMIN_BODY: "UPDATE_REACTIVATE_RENEW_ADMIN_BODY",
  UPDATE_REACTIVATE_RENEW_MASSIVE_BODY: "UPDATE_REACTIVATE_RENEW_MASSIVE_BODY",
  GET_EXTERNAL_PORTAL_COMBO_OPTIONS: "GET_EXTERNAL_PORTAL_COMBO_OPTIONS",
  GET_EXTERNAL_PORTAL_COMBO_OPTIONS_SUCCESS:
    "GET_EXTERNAL_PORTAL_COMBO_OPTIONS_SUCCESS",
  GET_EXTERNAL_PORTAL_COMBO_OPTIONS_FAILURE:
    "GET_EXTERNAL_PORTAL_COMBO_OPTIONS_FAILURE",
  RESET_FISCAL_CODE_CHECK: "RESET_FISCAL_CODE_CHECK",
  RESET_ATTACHMENTS_STATE: "RESET_ATTACHMENTS_STATE",
  EXTERNAL_PORTAL_INSERT_USER: "EXTERNAL_PORTAL_INSERT_USER",
  EXTERNAL_PORTAL_INSERT_USER_SUCCESS: "EXTERNAL_PORTAL_INSERT_USER_SUCCESS",
  EXTERNAL_PORTAL_INSERT_USER_FAILURE: "EXTERNAL_PORTAL_INSERT_USER_FAILURE",
  EXTERNAL_PORTAL_UPDATE_USER: "EXTERNAL_PORTAL_UPDATE_USER",
  EXTERNAL_PORTAL_UPDATE_USER_SUCCESS: "EXTERNAL_PORTAL_UPDATE_USER_SUCCESS",
  EXTERNAL_PORTAL_UPDATE_USER_FAILURE: "EXTERNAL_PORTAL_UPDATE_USER_FAILURE",
  GET_USER_TYPE_THAT_CAN_BE_CREATED: "GET_USER_TYPE_THAT_CAN_BE_CREATED",
  GET_USER_TYPE_THAT_CAN_BE_CREATED_SUCCESS:
    "GET_USER_TYPE_THAT_CAN_BE_CREATED_SUCCESS",
  GET_USER_TYPE_THAT_CAN_BE_CREATED_FAILURE:
    "GET_USER_TYPE_THAT_CAN_BE_CREATED_FAILURE",
  MANIPOLATE_ORGANIZATIONAL_UNITS: "MANIPOLATE_ORGANIZATIONAL_UNITS",
  RESET_REACTIVATE_BODIES: "RESET_REACTIVATE_BODIES",
  DELETE_ATTACHMENT: "DELETE_ATTACHMENT",
  DELETE_ATTACHMENT_SUCCESS: "DELETE_ATTACHMENT_SUCCESS",
  DELETE_ATTACHMENT_FAILURE: "DELETE_ATTACHMENT_FAILURE",
};

export const resetReactivateBodies = () => ({
  type: actionTypes.RESET_REACTIVATE_BODIES,
});

export const updateReactivateRenewAdminBody = (payload: any) => ({
  type: actionTypes.UPDATE_REACTIVATE_RENEW_ADMIN_BODY,
  payload,
});

export const updateReactivateRenewMassiveBody = (payload: any) => ({
  type: actionTypes.UPDATE_REACTIVATE_RENEW_MASSIVE_BODY,
  payload,
});

export const deleteAttachment = (payload: any) => ({
  type: actionTypes.DELETE_ATTACHMENT,
  payload,
});

export const deleteAttachmentSuccess = (payload: any) => ({
  type: actionTypes.DELETE_ATTACHMENT_SUCCESS,
  payload,
});

export const deleteAttachmentFailure = (err: Error) => ({
  type: actionTypes.DELETE_ATTACHMENT_FAILURE,
  err,
});

export const getButtons = (payload: any) => ({
  type: actionTypes.GET_BUTTONS,
  payload,
});

export const getButtonsSuccess = (payload: any) => ({
  type: actionTypes.GET_BUTTONS_SUCCESS,
  payload,
});

export const getButtonsFailure = (err: Error) => ({
  type: actionTypes.GET_BUTTONS_FAILURE,
  err,
});

export const getFieldVisibility = (payload: any) => ({
  type: actionTypes.GET_FIELD_VISIBILITY,
  payload,
});

export const getFieldVisibilitySuccess = (payload: any) => ({
  type: actionTypes.GET_FIELD_VISIBILITY_SUCCESS,
  payload,
});

export const getFieldVisibilityFailure = (err: Error) => ({
  type: actionTypes.GET_FIELD_VISIBILITY_FAILURE,
  err,
});

export const getOuByUserType = (payload: any) => ({
  type: actionTypes.GET_OU_BY_USERTYPE,
  payload,
});

export const getManagers = (payload: any | null) => ({
  type: actionTypes.GET_MANAGERS,
  payload,
});

export const getManagersSuccess = (payload: any) => ({
  type: actionTypes.GET_MANAGERS_SUCCESS,
  payload,
});

export const getManagersFailure = (err: Error) => ({
  type: actionTypes.GET_MANAGERS_FAILURE,
  err,
});

export const getReferrals = (payload: any | null) => ({
  type: actionTypes.GET_REFERRALS,
  payload,
});

export const getReferralsSuccess = (payload: any) => ({
  type: actionTypes.GET_REFERRALS_SUCCESS,
  payload,
});

export const getReferralsFailure = (err: Error) => ({
  type: actionTypes.GET_REFERRALS_FAILURE,
  err,
});

export const getOrganizationalUnits = (payload: any | null) => ({
  type: actionTypes.GET_ORGANIZATIONAL_UNITS,
  payload,
});

export const getOrganizationalUnitsSuccess = (payload: any) => ({
  type: actionTypes.GET_ORGANIZATIONAL_UNITS_SUCCESS,
  payload,
});

export const getOrganizationalUnitsFailure = (err: Error) => ({
  type: actionTypes.GET_ORGANIZATIONAL_UNITS_FAILURE,
  err,
});

export const getOrganizationalUnitsBySelectedRoles = (payload: any) => ({
  type: actionTypes.GET_ORGANIZATIONAL_UNITS_BY_SELECTED_ROLES,
  payload,
});

export const getOrganizationalUnitsBySelectedRolesSuccess = (payload: any) => ({
  type: actionTypes.GET_ORGANIZATIONAL_UNITS_BY_SELECTED_ROLES_SUCCESS,
  payload,
});

export const getOrganizationalUnitsBySelectedRolesFailure = (err: Error) => ({
  type: actionTypes.GET_ORGANIZATIONAL_UNITS_BY_SELECTED_ROLES_FAILURE,
  err,
});

export const getUserWithAlreadyExistingFiscalCode = (payload: any) => ({
  type: actionTypes.GET_USER_WITH_ALREADY_EXISTING_FISCAL_CODE,
  payload,
});

export const getUserWithAlreadyExistingFiscalCodeSuccess = (payload: any) => ({
  type: actionTypes.GET_USER_WITH_ALREADY_EXISTING_FISCAL_CODE_SUCCESS,
  payload,
});

export const getUserWithAlreadyExistingFiscalCodeFailure = (err: Error) => ({
  type: actionTypes.GET_USER_WITH_ALREADY_EXISTING_FISCAL_CODE_FAILURE,
  err,
});

export const saveSocietyValidation = (payload: any) => ({
  type: actionTypes.SAVE_SOCIETY_VALIDATION,
  payload,
});

export const saveSocietyValidationSuccess = (payload: any) => ({
  type: actionTypes.SAVE_SOCIETY_VALIDATION_SUCCESS,
  payload,
});

export const saveSocietyValidationFailure = (err: Error) => ({
  type: actionTypes.SAVE_SOCIETY_VALIDATION_FAILURE,
  err,
});

export const getCompanies = () => ({
  type: actionTypes.GET_COMPANIES,
});

export const getCompaniesSuccess = (payload: any) => ({
  type: actionTypes.GET_COMPANIES_SUCCESS,
  payload,
});

export const getCompaniesFailure = (err: Error) => ({
  type: actionTypes.GET_COMPANIES_FAILURE,
  err,
});

export const getOffices = () => ({
  type: actionTypes.GET_OFFICES,
});

export const getOfficesSuccess = (payload: any) => ({
  type: actionTypes.GET_OFFICES_SUCCESS,
  payload,
});

export const getOfficesFailure = (err: Error) => ({
  type: actionTypes.GET_OFFICES_FAILURE,
  err,
});

export const renewUser = (payload: any) => ({
  type: actionTypes.RENEW_USER,
  payload,
});

export const renewUserSuccess = (payload: any) => ({
  type: actionTypes.RENEW_USER_SUCCESS,
  payload,
});

export const renewUserFailure = (err: Error) => ({
  type: actionTypes.RENEW_USER_FAILURE,
  err,
});

export const renewUserAdmin = (payload: any) => ({
  type: actionTypes.RENEW_USER_ADMIN,
  payload,
});

export const renewUserAdminSuccess = (payload: any) => ({
  type: actionTypes.RENEW_USER_ADMIN_SUCCESS,
  payload,
});

export const renewUserAdminFailure = (err: Error) => ({
  type: actionTypes.RENEW_USER_ADMIN_FAILURE,
  err,
});

export const reactivateOutsourcer = (payload: any) => ({
  type: actionTypes.REACTIVATE_OUTSOURCER,
  payload,
});

export const reactivateOutsourcerSuccess = (payload: any) => ({
  type: actionTypes.REACTIVATE_OUTSOURCER_SUCCESS,
  payload,
});

export const reactivateOutsourcerFailure = (err: Error) => ({
  type: actionTypes.REACTIVATE_OUTSOURCER_FAILURE,
  err,
});

export const reactivateConsultant = (payload: any) => ({
  type: actionTypes.REACTIVATE_CONSULTANT,
  payload,
});

export const reactivateConsultantSuccess = (payload: any) => ({
  type: actionTypes.REACTIVATE_CONSULTANT_SUCCESS,
  payload,
});

export const reactivateConsultantFailure = (err: Error) => ({
  type: actionTypes.REACTIVATE_CONSULTANT_FAILURE,
  err,
});

export const reactivateUser = (payload: any) => ({
  type: actionTypes.REACTIVATE_USER,
  payload,
});

export const reactivateUserSuccess = (payload: any) => ({
  type: actionTypes.REACTIVATE_USER_SUCCESS,
  payload,
});

export const reactivateUserFailure = (err: Error) => ({
  type: actionTypes.REACTIVATE_USER_FAILURE,
  err,
});

export const reactivateAdmin = (payload: any) => ({
  type: actionTypes.REACTIVATE_ADMIN,
  payload,
});

export const reactivateAdminSuccess = (payload: any) => ({
  type: actionTypes.REACTIVATE_ADMIN_SUCCESS,
  payload,
});

export const reactivateAdminFailure = (err: Error) => ({
  type: actionTypes.REACTIVATE_ADMIN_FAILURE,
  err,
});

export const blockUser = (payload: any) => ({
  type: actionTypes.BLOCK_USER,
  payload,
});

export const blockUserSuccess = (payload: any) => ({
  type: actionTypes.BLOCK_USER_SUCCESS,
  payload,
});

export const blockUserFailure = (err: Error) => ({
  type: actionTypes.BLOCK_USER_FAILURE,
  err,
});

export const terminateOutsourcer = (payload: any) => ({
  type: actionTypes.TERMINATE_OUTSOURCER,
  payload,
});

export const terminateOutsourcerSuccess = (payload: any) => ({
  type: actionTypes.TERMINATE_OUTSOURCER_SUCCESS,
  payload,
});

export const terminateOutsourcerFailure = (err: Error) => ({
  type: actionTypes.TERMINATE_OUTSOURCER_FAILURE,
  err,
});

export const terminateConsultant = (payload: any) => ({
  type: actionTypes.TERMINATE_CONSULTANT,
  payload,
});

export const terminateConsultantSuccess = (payload: any) => ({
  type: actionTypes.TERMINATE_CONSULTANT_SUCCESS,
  payload,
});

export const terminateConsultantFailure = (err: Error) => ({
  type: actionTypes.TERMINATE_CONSULTANT_FAILURE,
  err,
});

export const terminateSecurity = (payload: any) => ({
  type: actionTypes.TERMINATE_SECURITY,
  payload,
});

export const terminateSecuritySuccess = (payload: any) => ({
  type: actionTypes.TERMINATE_SECURITY_SUCCESS,
  payload,
});

export const terminateSecurityFailure = (err: Error) => ({
  type: actionTypes.TERMINATE_SECURITY_FAILURE,
  err,
});

export const validateUsers = (payload: any) => ({
  type: actionTypes.VALIDATE_USERS,
  payload,
});

export const validateUsersSuccess = (payload: any) => ({
  type: actionTypes.VALIDATE_USERS_SUCCESS,
  payload,
});

export const validateUsersFailure = (err: Error) => ({
  type: actionTypes.VALIDATE_USERS_FAILURE,
  err,
});

export const disableOutsourcer = (payload: any) => ({
  type: actionTypes.DISABLE_OUTSOURCER,
  payload,
});

export const disableOutsourcerSuccess = (payload: any) => ({
  type: actionTypes.DISABLE_OUTSOURCER_SUCCESS,
  payload,
});

export const disableOutsourcerFailure = (err: Error) => ({
  type: actionTypes.DISABLE_OUTSOURCER_FAILURE,
  err,
});

export const disableConsultant = (payload: any) => ({
  type: actionTypes.DISABLE_CONSULTANT,
  payload,
});

export const disableConsultantSuccess = (payload: any) => ({
  type: actionTypes.DISABLE_CONSULTANT_SUCCESS,
  payload,
});

export const disableConsultantFailure = (err: Error) => ({
  type: actionTypes.DISABLE_CONSULTANT_FAILURE,
  err,
});

export const getUsersValidationInfo = (payload: any) => ({
  type: actionTypes.GET_USERS_VALIDATION_INFO,
  payload,
});

export const getUsersValidationInfoSuccess = (payload: any) => ({
  type: actionTypes.GET_USERS_VALIDATION_INFO_SUCCESS,
  payload,
});

export const getUsersValidationInfoFailure = (err: Error) => ({
  type: actionTypes.GET_USERS_VALIDATION_INFO_FAILURE,
  err,
});

export const setUserDetail = (payload: any) => ({
  type: actionTypes.SET_USER_DETAIL,
  payload,
});

export const getAllRolesRequest = () => ({
  type: actionTypes.GET_ALL_ROLES_REQUEST,
});

export const modifySelectedUsers = (payload: any[]) => ({
  type: actionTypes.MODIFY_SELECTED_USERS,
  payload,
});

export const getAllRolesRequestSuccess = (payload: any) => ({
  type: actionTypes.GET_ALL_ROLES_REQUEST_SUCCESS,
  payload,
});

export const getAllRolesRequestFailure = (err: Error) => ({
  type: actionTypes.GET_ALL_ROLES_REQUEST_FAILURE,
  err,
});

export const setRoleSelectedRequest = (payload: any[]) => ({
  type: actionTypes.SET_ROLE_SELECTED_REQUEST,
  payload,
});

export const paginatedUserRequest = (payload: any) => ({
  type: actionTypes.PAGINATED_USERS_REQUEST,
  payload,
});

export const paginatedUserRequestSuccess = (payload: any) => ({
  type: actionTypes.PAGINATED_USERS_REQUEST_SUCCESS,
  payload,
});

export const paginatedUserRequestFailure = (err: Error) => ({
  type: actionTypes.PAGINATED_USERS_REQUEST_FAILURE,
  err,
});

export const updateUserInfo = (id: string, payload: any) => ({
  type: actionTypes.UPDATE_USER_INFO,
  id,
  payload,
});

export const updateUserInfoSuccess = (payload: any) => ({
  type: actionTypes.UPDATE_USER_INFO_SUCCESS,
  payload,
});

export const updateUserInfoFailure = (err: Error) => ({
  type: actionTypes.UPDATE_USER_INFO_FAILURE,
  err,
});

export const enableBadgeToUser = (payload: any) => ({
  type: actionTypes.ENABLE_BADGE_TO_USER,
  payload,
});

export const enableBadgeToUserSuccess = (payload: any) => ({
  type: actionTypes.ENABLE_BADGE_TO_USER_SUCCESS,
  payload,
});

export const enableBadgeToUserFailure = (err: Error) => ({
  type: actionTypes.ENABLE_BADGE_TO_USER_FAILURE,
  err,
});

export const getUserAttachmentsInfo = (payload: any) => ({
  type: actionTypes.GET_USER_ATTACHMENTS_INFO,
  payload,
});

export const getUserAttachmentsInfoSuccess = (payload: any) => ({
  type: actionTypes.GET_USER_ATTACHMENTS_INFO_SUCCESS,
  payload,
});

export const getUserAttachmentsInfoFailure = (err: Error) => ({
  type: actionTypes.GET_USER_ATTACHMENTS_INFO_FAILURE,
  err,
});

export const resetAttachmentsState = () => ({
  type: actionTypes.RESET_ATTACHMENTS_STATE,
});

export const getUserAdminLettersInfo = (payload: any) => ({
  type: actionTypes.GET_USER_ADMIN_LETTERS_INFO,
  payload,
});

export const getUserAdminLettersInfoSuccess = (payload: any) => ({
  type: actionTypes.GET_USER_ADMIN_LETTERS_INFO_SUCCESS,
  payload,
});

export const getUserAdminLettersInfoFailure = (err: Error) => ({
  type: actionTypes.GET_USER_ADMIN_LETTERS_INFO_FAILURE,
  err,
});

export const uploadAttachmentsToAdminLettersRequest = (payload: any) => ({
  type: actionTypes.UPLOAD_ATTACHMENTS_TO_ADMIN_LETTERS,
  payload,
});

export const uploadAttachmentsToAdminLettersRequestSuccess = (
  payload: any
) => ({
  type: actionTypes.UPLOAD_ATTACHMENTS_TO_ADMIN_LETTERS_SUCCESS,
  payload,
});

export const uploadAttachmentsToAdminLettersRequestFailure = (err: Error) => ({
  type: actionTypes.UPLOAD_ATTACHMENTS_TO_ADMIN_LETTERS_FAILURE,
  err,
});

export const uploadAttachmentsToUsersRequest = (payload: any) => ({
  type: actionTypes.UPLOAD_ATTACHMENTS_TO_USERS,
  payload,
});

export const uploadAttachmentsToUsersRequestSuccess = (payload: any) => ({
  type: actionTypes.UPLOAD_ATTACHMENTS_TO_USERS_SUCCESS,
  payload,
});

export const uploadAttachmentsToUsersRequestFailure = (err: Error) => ({
  type: actionTypes.UPLOAD_ATTACHMENTS_TO_USERS_FAILURE,
  err,
});

export const resetStateExternalPortal = () => ({
  type: actionTypes.RESET_STATE_EXTERNAL_PORTAL,
});

export const getExternalPortalComboOptions = (payload: any) => ({
  type: actionTypes.GET_EXTERNAL_PORTAL_COMBO_OPTIONS,
  payload,
});
export const getExternalPortalComboOptionsSuccess = (payload: any) => ({
  type: actionTypes.GET_EXTERNAL_PORTAL_COMBO_OPTIONS_SUCCESS,
  payload,
});
export const getExternalPortalComboOptionsFailure = (error: any) => ({
  type: actionTypes.GET_EXTERNAL_PORTAL_COMBO_OPTIONS_FAILURE,
  error,
});

export const resetFiscalCodeCheckAction = () => ({
  type: actionTypes.RESET_FISCAL_CODE_CHECK,
});

export const externalPortalInsertUser = (payload: any) => ({
  type: actionTypes.EXTERNAL_PORTAL_INSERT_USER,
  payload,
});
export const externalPortalInsertUserSuccess = (payload: any) => ({
  type: actionTypes.EXTERNAL_PORTAL_INSERT_USER_SUCCESS,
  payload,
});
export const externalPortalInsertUserFailure = (error: any) => ({
  type: actionTypes.EXTERNAL_PORTAL_INSERT_USER_FAILURE,
  error,
});

export const externalPortalUpdateUser = (payload: any) => ({
  type: actionTypes.EXTERNAL_PORTAL_UPDATE_USER,
  payload,
});
export const externalPortalUpdateUserSuccess = (payload: any) => ({
  type: actionTypes.EXTERNAL_PORTAL_UPDATE_USER_SUCCESS,
  payload,
});
export const externalPortalUpdateUserFailure = (error: any) => ({
  type: actionTypes.EXTERNAL_PORTAL_UPDATE_USER_FAILURE,
  error,
});

export const getUserTypeThatCanBeCreated = (payload: any) => ({
  type: actionTypes.GET_USER_TYPE_THAT_CAN_BE_CREATED,
  payload,
});
export const getUserTypeThatCanBeCreatedSuccess = (payload: any) => ({
  type: actionTypes.GET_USER_TYPE_THAT_CAN_BE_CREATED_SUCCESS,
  payload,
});
export const getUserTypeThatCanBeCreatedFailure = (error: any) => ({
  type: actionTypes.GET_USER_TYPE_THAT_CAN_BE_CREATED_FAILURE,
  error,
});

export const manipolateOu = (payload: any) => ({
  type: actionTypes.MANIPOLATE_ORGANIZATIONAL_UNITS,
  payload,
});
